import React, { createContext, useState, useEffect, useContext } from 'react'
import { getLayerTypes, getControls } from './mapConfig'
import { getLayerState } from './layers/getLayer'
import { DataContext } from './DataContext'
import withConfig from '../../../wrappers/withConfig'

const MapControlContext = createContext(null)

const MapControlContextProvider = ({ children, config }) => {
    const { layerData } = useContext(DataContext)
    const [layerTypes] = useState(getLayerTypes())
    const [displayMapLayers, toggleMapLayers] = useState(false)
    const [controls, setControls] = useState(getControls(layerTypes))
    const [layerState, setLayerState] = useState(getLayerState(layerData, null, config.DEFAULT_THEME_DISPLAY_LAYERNAME))

    const [activeControl, setActiveControl] = useState(null)
    const [displayTooltip, toggleTooltip] = useState(false)

    const clearControls = () => {
        const newControls = Object.keys(controls).reduce((acc, controlName) => {
            const control = controls[controlName]
            control.active = false
            return {
                ...acc,
                [controlName]: control,
            }
        }, {})
        setControls(newControls)
        setActiveControl(null)
    }

    const activateControl = name => {
        clearControls()
        const newControls = Object.keys(controls).reduce((acc, controlName) => {
            const control = controls[controlName]
            if (controlName === name) {
                control.active = true
            }
            return {
                ...acc,
                [controlName]: control,
            }
        }, {})
        setControls(newControls)
        setActiveControl(name)
    }

    // update layer state when layers change
    useEffect(() => {
        setLayerState(prevLayerState => getLayerState(layerData, prevLayerState, config.DEFAULT_THEME_DISPLAY_LAYERNAME))
    }, [layerData])

    return (
        <MapControlContext.Provider
            value={{
                controls,
                activeControl,
                activateControl,
                clearControls,
                displayTooltip,
                toggleTooltip,
                displayMapLayers,
                toggleMapLayers,
                layerState,
                setLayerState
            }}
        >
            {children}
        </MapControlContext.Provider>
    )
}

export { MapControlContext }
export default withConfig(MapControlContextProvider)
